import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import Field from '@/models/Field.js'

export const useFieldStore = defineStore('fieldStore', () => {
  let syncableModel = useSyncableModel(useApiResource('fields'), {
    className: Field.modelName.name,
    paramKey: Field.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})
